import { get } from "_src/utils/http";
// 通用接口
// 获取作品列表
export function getList(data) {
  return get("/api/inftspace/works/v1/get_list", data).then((res) => {
    return res;
  });
}

//获取币种汇率
export function getSymbolRate(data) {
  return get("/api/inftspace/config/v1/get_symbol_rate", data).then((res) => {
    return res;
  });
}

//添加收藏
export function addFavorites(data) {
  return get("/api/inftspace/favorites/v1/add", data).then((res) => {
    return res;
  });
}

//删除收藏
export function delFavorites(data) {
  return get("/api/inftspace/favorites/v1/del", data).then((res) => {
    return res;
  });
}

//是否被收藏
export function isFavorated(data) {
  return get("/api/inftspace/favorites/v1/is_favorated", data).then((res) => {
    return res;
  });
}
